<div class="theme-designer" [class.hide]="isMultiWindow">
  <mat-tab-group>
    <mat-tab *ngFor="let group of vars | keyvalue">
      <ng-template mat-tab-label>
        <div class="variables-tab" [class.modified]="isGroupModified(group)">{{ group.key }}</div>
      </ng-template>

      <div class="variables-list">
        <div
          *ngFor="let _var of group.value"
          [class.modified]="_var.value !== _var.original"
          class="variables-list__item">
          <div class="item__content">
            <span
              class="item__content__representation"
              [class.active]="_var.color !== 'none'"
              [ngStyle]="{ background: _var.value }"></span>

            <div class="wrapper">
              <p class="item__content__text">{{ _var.key }}</p>
              <input
                class="item__content__input"
                [class.with-picker]="_var.color !== 'none'"
                type="text"
                [value]="_var.value"
                (change)="valueChange(_var, $event)"
                (focus)="focusIn(_var)"
                (focusout)="focusOut(_var)" />
            </div>

            <button class="item__content__reset" (click)="resetValue(_var)">RESET</button>
          </div>

          <color-chrome
            *ngIf="_var.picker"
            [color]="_var.value"
            (onChangeComplete)="onColorChange(_var, $event)"
            (mousedown)="onEvent(_var, $event)"></color-chrome>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="theme-designer__actions">
    <button (click)="saveTheme()" class="actions__save">SAVE</button>
    <button class="actions__reset" (click)="resetAll()">RESET ALL</button>
  </div>
</div>
